import React, { useEffect, useRef, useState } from 'react';
import Editor from '@monaco-editor/react';
import { Card } from 'antd';


function SourceCode({ html, setHtml ,trigger,placeHolders}) {

  
  function handleEditorChange(value, event) {
    setHtml(value);
  }
 
  const editorRef = useRef(null);
  const monacoRef = useRef(null);

  const handleEditorMount = (editor, monaco) => {
    editorRef.current = editor;
    monacoRef.current = monaco;
  };


  const insertTag = (tagValue) => {

    const editor = editorRef.current;
    const monaco = monacoRef.current;

    if (!editor || !monaco) return;

    const position = editor.getPosition();

    const range = new monaco.Range(
      position.lineNumber,
      position.column,
      position.lineNumber,
      position.column
    );

    editor.executeEdits('', [
      {
        range,
        text: " " + "{{"+tagValue+"}}"+" ",
        forceMoveMarkers: true,
      },
    ]);

    editor.focus();
  };

  
  return (

    <div key={trigger} style={{ display: 'flex', gap: '5px', padding: '0px' }}>

      <div style={trigger === 1 ? {width:'80%'} : {width:'100%'}}>
      <Editor
        height={"80vh"}
        theme="vs-dark"
        defaultLanguage="html"
        defaultValue={html}
        onChange={handleEditorChange}
        onMount={handleEditorMount}
      />
      </div>
      {/* Tags column */}
{
  trigger === 1 &&

    (
      <Card type="inner" className={'template-placeHolder-list'} style={{ width: 300, height: '80vh', overflowY: 'auto' }} title="Add Placeholder">
     {
    placeHolders?.length > 0 ? 
     placeHolders.map((tag) => (
          <div
            key={tag}
            onClick={() => insertTag(tag)}
            style={{
              cursor: 'pointer',
              padding: '8px 12px',
              marginBottom: '10px',
              // border: '1px solid #1890ff',
              borderRadius: '6px',
              backgroundColor: '#ffffff',
              // color: '#1890ff',
              fontWeight: 500,
              textAlign: 'center',
              transition: 'all 0.25s ease',
              boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
            }}
            onMouseEnter={(e) => {
              // e.currentTarget.style.backgroundColor = '#bae7ff';
              e.currentTarget.style.boxShadow = '0 2px 6px #d6ceceff'
            }}
            onMouseLeave={(e) => {
              // e.currentTarget.style.backgroundColor = '#e6f7ff';
              e.currentTarget.style.boxShadow = '0 1px 2px #d6ceceff'
            }}
          >
            {tag}
          </div>
        )):
        <p>Data not found</p>
      }
    </Card>
    )
    
}
     

    </div>
  );
}

export default SourceCode;
